export default __webpack_public_path__ + "static/media/classicDom.fcfdbc24.png";